// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3xtvl","content":"styles_content__34zRl","selectAll":"styles_selectAll__t211X"};